// FIFA WC 2026 nation kit colors — [primary, secondary] used for jersey rendering.
// Selective WC craft (premium surface). Fallback is a neutral slate kit.

const NATION_KITS = {
  Argentina: ["#75AADB", "#ffffff"],
  Brazil: ["#FEDF00", "#009C3B"],
  France: ["#1E3A8A", "#ffffff"],
  England: ["#ffffff", "#CF142B"],
  Spain: ["#C60B1E", "#FABD00"],
  Germany: ["#111827", "#DD0000"],
  Portugal: ["#C8102E", "#006847"],
  Netherlands: ["#FF6A13", "#ffffff"],
  Belgium: ["#C8102E", "#FDDA24"],
  Italy: ["#0067A6", "#ffffff"],
  Croatia: ["#C8102E", "#ffffff"],
  Mexico: ["#006847", "#ffffff"],
  "United States": ["#1E3A8A", "#ffffff"],
  USA: ["#1E3A8A", "#ffffff"],
  Uruguay: ["#5C9BE0", "#111827"],
  Morocco: ["#C1272D", "#006233"],
  Japan: ["#0B3D91", "#ffffff"],
  "South Korea": ["#0B3D91", "#C8102E"],
  Senegal: ["#00853F", "#FDEF42"],
  Switzerland: ["#D52B1E", "#ffffff"],
  Denmark: ["#C8102E", "#ffffff"],
  Canada: ["#C8102E", "#ffffff"],
};

const FALLBACK_PALETTE = [
  ["#475569", "#0f172a"], ["#7c3aed", "#1e1b4b"], ["#0891b2", "#083344"],
  ["#b45309", "#1c1917"], ["#be123c", "#1f0a12"], ["#15803d", "#052e16"],
];

export function teamKit(teamName, teamId) {
  if (teamName && NATION_KITS[teamName]) return NATION_KITS[teamName];
  const idx = Math.abs(((teamId || 0) + (teamName?.length || 0))) % FALLBACK_PALETTE.length;
  return FALLBACK_PALETTE[idx];
}

// Pick readable text color (black/white) against a hex background.
export function readableOn(hex) {
  const h = (hex || "#000").replace("#", "");
  const r = parseInt(h.substring(0, 2), 16) || 0;
  const g = parseInt(h.substring(2, 4), 16) || 0;
  const b = parseInt(h.substring(4, 6), 16) || 0;
  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
  return luminance > 0.6 ? "#0f172a" : "#ffffff";
}

export function initialsOf(name) {
  if (!name) return "?";
  const parts = name.trim().split(/\s+/);
  if (parts.length === 1) return parts[0].substring(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}
